module.exports = __webpack_public_path__ + "static/media/mid.2df951e5.svg";